import { Pipe, PipeTransform } from '@angular/core';
import { ServerIncidentsComponent } from 'projects/login/src/app/services/server-status/models/server-incidents-component';

@Pipe({
  name: 'componentsToText',
})
export class ComponentsToTextPipe implements PipeTransform {
  transform(input: ServerIncidentsComponent[]): unknown {
    return input.map((x) => x.name).join(', ');
  }
}
